<div>
  <div class="section-title">
    {{ 'LISTING_SYNC.SOURCE_MENU.DETAILS' | translate }}
  </div>

  @for (err of errors; track err) {
    <div class="error-message" [innerHTML]="err.message"></div>
    @if (err?.listedFields?.length > 0) {
      <ul>
        @for (field of err.listedFields; track field) {
          <li>{{ field }}</li>
        }
      </ul>
    }
  }

  @if (canForceSync) {
    <button (click)="forceSync()" data-action="force-sync" class="sidebar-button" color="primary" mat-flat-button>
      {{ 'LISTING_SYNC.SOURCE_MENU.FORCE_SYNC' | translate: { source: sourceName } }}
    </button>
  }
</div>
